module.exports = __webpack_public_path__ + "img/calendar.cbda3ab3.svg";